<template>
  <v-card v-if="model.id" class="elevation-2">
    <v-card-title class="text-h5">
      <h2 class="font-weight-bold text--primary"> Solicitudes Bajas </h2>
    </v-card-title>
    <v-card-subtitle class="title text--black font-weight-black font-weight-bold">
        {{`[ ${model.folio} ]`}}
    </v-card-subtitle>
    <v-tabs v-model="tab" background-color="primary" align-with-title dark>
      <v-tabs-slider color="white"></v-tabs-slider>
      <v-tab href="#General">General</v-tab>
      <!-- <v-tab href="#two" @click="viewEquipo()">Equipo Computo</v-tab> -->
      <v-tab href="#Movimientos" @click="viewMovs(model.folio)">Bitácora de Movimientos</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <!-- General -->
      <v-tab-item value="General">
        <v-card width="auto" outlined>
          <v-card-text>
            <v-row dense>
              <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary"> Folio </label>
                    <p class="font-weight-bold text--secondary">
                        {{model?.folio}}
                    </p>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary"> Depto. Tramitante </label>
                    <p class="font-weight-bold text--secondary">
                        {{model.departamento?.nombre || '' }}
                    </p>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <label class="font-weight-bold subtitle-1 text--primary"> Total De Bajas </label>
                    <p class="font-weight-bold text--secondary ">
                        {{model?.NumBajas}}
                    </p>
                </v-col>
                <v-col cols="12" sm="12" md="12" class="scroll-box">
                    <label class="font-weight-bold subtitle-1 text--primary">Lista De Bajas: </label>
                    <v-simple-table fixed-header dense>
                <thead>
                  <tr>
                    <th class="text-center">no. Inventario</th>
                    <th class="text-center">Familia</th>
                    <th class="text-center">Departamento</th>
                    <th class="text-center">Estado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(p) in model.bajas" :key="p.id">
                    <td class="text-center">{{ p.folio }}</td>
                    <td class="text-center">{{ p.familia.nombre }}</td>
                    <td class="text-center">{{ p.departamento.nombre }}</td>
                    <td class="text-center">{{ p.caracteristicas.conceptos.conceptos }}</td>
                  </tr>
                </tbody>
              </v-simple-table>

                </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>
          <!-- Inventario -->
          <v-tab-item value="two">
            <v-card width="auto" outlined>
              <v-card-text>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- Bitacorra -->
          <v-tab-item value="Movimientos">
            <v-card width="auto" outlined>
              <v-card-text>
                <v-row dense>
                  <v-col v-if="showMovs" cols="12">
                    <ViewMovementsField :itemAction="movs" />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
      </v-tabs-items>
    </v-card>
    <!--
    <v-card v-if="model.id" class="elevation-2">
      <v-card-text>
      </v-card-text>
    </v-card>
  -->
  </template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import ViewMovementsField from '@/components/fields/specific/ViewMovementsField'
export default {
  props: ['model'],
  data: () => ({
    tab: 0,
    movs: {
      field: 'showMovsDataServer',
      name: '',
      nameid: 'movimientos',
      url: '/procesos/movimientos',
      default: '/procesos/movimientos',
      hidden: true,
      cols: 12
    },
    showMovs: false,
    showEq: false,
    itemInsumos: {}
  }),
  components: {
    ViewMovementsField
  },
  methods: {
    ...mapMutations(['SHOW_DIALOG_MAIN']),
    successAction (item) {
      this[item.action](item)
    },
    addInsumosView (item) {
      this.itemInsumos = {}
      this.itemInsumos = Object.assign({}, item.item)
      this.SHOW_DIALOG_MAIN({ type: 'addInsumos', with: 900, title: 'Agregar Insumos' })
    },
    returnedInsumosView (item) {},
    viewMovs (folio) {
      this.showMovs = false
      this.movs.url = `${this.movs.default}?folio=${folio}&mov=all`
      setTimeout(() => { this.showMovs = true }, 200)
    },
    viewEquipo () {
    /*
        if (this.model.descripcion.equipo) return
        this.showEq = false
        const router = this.get_urls['catalogo.familias-caracteristica.formulario']
        this.urlGetServiceActionTwo({ url: router, params: `/${this.model.descripcion.inventario.caracteristicas.familia_id}`, replace: '/{id}' })
        setTimeout(() => { this.showEq = true }, 200)
    */
    }
  },
  computed: {
    ...mapGetters(['get_dialogMain'])
  },
  watch: {
    model (obj) {
      this.tab = 0
    }
  }
}
</script>
<style scoped>
.scroll-box {
  max-height: 250px;
  overflow-x: auto;
}
.scroll-box::-webkit-scrollbar {
  width: 8px;/* width of the entire scrollbar */
}

.scroll-box::-webkit-scrollbar-track {
  background: #d2d2d2;/* color of the tracking area */
  border-radius: 10px;
}
.scroll-box::-webkit-scrollbar-thumb {
  background-color: #3F51B5;  /* color of the scroll thumb */
  border-radius: 10px;       /* roundness of the scroll thumb */
  border: -7px solid #d2d2d2;/* creates padding around scroll thumb */
}

/* .cuadro{
  padding-left: 150px;
  padding-right: 150px;
  margin-top: 2px;
  margin-bottom: 15px;
}
.cuadro2{
  padding-left: 120px;
  padding-right: 30px;
} */
</style>
